import { MonoBehavior } from 'game/core/monoBehavior';
import { getScreenSize } from 'game/core/screen';
import { Sprite, Texture } from 'pixi.js';

export class ExternalClickArea extends MonoBehavior {
    bounds: Sprite;

    constructor() {
        super();
        this.bounds = new Sprite(Texture.WHITE);
        this.bounds.interactive = true;
        this.bounds.alpha = 0;

        this.resize();
    }

    resize(): void {
        const { width, height } = getScreenSize();

        this.bounds.position.set(- width / 2, -height / 2);
        this.bounds.width = width;
        this.bounds.height = height;
    }
}
